import type { MarketplaceLead, MarketplaceLeadStatus } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { BANK_MARKETPLACE_LEADS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateBankMarketplaceLead() {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();
  const queryClient = useQueryClient();

  const { mutateAsync: updateBankMarketplaceLead, isPending: isPutBankMarketplaceLeadPending } = useMutation({
    mutationKey: [BANK_MARKETPLACE_LEADS_KEY],
    mutationFn: async (lead: {
      id: string;
      status: MarketplaceLeadStatus;
      internalComment?: string;
      externalComment?: string;
    }) =>
      await banksApi.updateMarketplaceLead(userBankId, lead.id, {
        status: lead.status,
        internalComment: lead.internalComment,
        externalComment: lead.externalComment
      }),
    onSuccess: (updatedLead) => {
      const bankMarketplaceLeads: MarketplaceLead[] | undefined = queryClient.getQueryData([
        BANK_MARKETPLACE_LEADS_KEY,
        userBankId
      ]);
      const existingLead = bankMarketplaceLeads?.findIndex((l) => l.id === updatedLead.id);
      if (existingLead != null && existingLead >= 0) {
        bankMarketplaceLeads?.splice(existingLead, 1, updatedLead);
      }
      return queryClient.setQueryData([BANK_MARKETPLACE_LEADS_KEY, userBankId], bankMarketplaceLeads);
    }
  });

  return { updateBankMarketplaceLead, isPutBankMarketplaceLeadPending };
}
